<template>
  <AppSection>
    <AppContainer>
      <AppThirdLayout>
        <AppHeaderWithImg 
          :text="$tt('faq')"
          src="/images/question-mark-illustration.jpg"
          :alt="$tt('faq_img')"
        />
        <v-expansion-panels variant="accordion" focusable>
          <v-expansion-panel v-for="{ q, a } in faqs">
            <v-expansion-panel-title>
              <h4 class="mb-0">{{ q }}</h4>
            </v-expansion-panel-title>
            <v-expansion-panel-text eager>
              <div v-html="a" />
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </AppThirdLayout>
    </AppContainer>
    <FaqEligibilityModal v-if="eligibleNationalityListVisible" v-model="eligibleNationalityListVisible" />
  </AppSection>
</template>

<script setup lang="ts">
import type { Faq } from '~/types';

defineProps<{
  faqs: Faq[];
}>();

const eligibleNationalityListVisible = ref(false);
useListener('click', 'eligibility-list-opener', () => {
  eligibleNationalityListVisible.value = true;
});
</script>

<style scoped lang="scss">
button {
  padding: var(--space-6) var(--space-2);
}
:deep(p), :deep(li) {
  font-size: 16px;
}
:deep(.v-expansion-panel__shadow) {
  box-shadow: none;
}
:deep(.v-expansion-panel-title--active) {
  .v-expansion-panel-title__overlay {
    opacity: 0 !important;
  }
}
:deep(.v-expansion-panel-text__wrapper) {
  padding: 0 var(--space-2) var(--space-5);
  padding-top: 0 !important;
}
:deep(td), :deep(th) {
  padding: var(--space-2);
}

@media (min-width: 851px) {
  h4, :deep(p) {
    padding-inline-end: var(--space-10);
  }
}
@media (max-width: 850px) {
  button {
    padding: var(--space-3) var(--space-2) var(--space-4);
  }
  h4 {
    font-size: 18px;
  }
}
</style>